<template>
  <div id="app">
    <v-app>
      <v-container grid-list-md text-xs-center>
        <v-layout row wrap>
          <v-container style="margin-top: -5px">
            <v-layout align-center justify-center height="52px">
              <v-flex shrink>
                <span
                  style="
                    font-family: Fredoka One;
                    font-style: normal;
                    font-weight: normal;
                    font-size: 43px;
                    line-height: 52px;
                    display: flex;
                    align-items: center;
                    text-align: center;
                    color: #18739d;
                    flex: none;
                    order: 3;
                    flex-grow: 0;
                    margin: 0px 0px;
                  "
                >
                  Voice Similarity
                </span>
              </v-flex>
            </v-layout>
            <p class="subheading" style="text-align: center; margin-top: 1%">
              This is a demonstration of Privately’s technology comparing if two audio samples come from the same
              speaker
            </p>
            <p class="subheading" style="text-align: center">
              Please provide audio samples either through your microphone, from files on your computer or choose from
              the samples provided below and press SUBMIT. For more information on how we process data, please refer to
              <a href="https://www.privately.eu/legal" target="_blank">our privacy policy </a>
            </p>
          </v-container>
          <v-container fluid fill-height style="margin-top: -50px">
            <v-layout row wrap>
              <v-flex xs12 sm6 md6 lg6>
                <v-container fluid fill-height>
                  <v-layout class="align-center justify-center">
                    <div style="text-align: center">
                      <span class="title custom-text">Select Speaker #1 </span>
                      <p class="title custom-text" style="margin-top: 5px">
                        <span style="font-size: 30px">&#8681;</span>
                      </p>
                      <v-card
                        height="55"
                        elevation="0"
                        class="d-flex align-center justify-center"
                        color="#eeeeee"
                        style="border-radius: 10px"
                      >
                        <v-select
                          style="margin-top: 5px; width: 10px"
                          :items="audios1"
                          label="Choose a preloaded sample"
                          @change="loadaudio(1, $event)"
                        >
                        </v-select>
                      </v-card>
                      <v-card class="d-flex align-center justify-center" elevation="0" color="transparent">
                        <p class="custom-text">OR</p>
                      </v-card>

                      <v-card
                        elevation="0"
                        height="55"
                        class="d-flex align-center justify-center"
                        color="#eeeeee"
                        style="border-radius: 10px"
                      >
                        <v-card-title class="file-upload justify-center">
                          <input
                            style="width: 200px"
                            class="form-control"
                            @change="customaudio('formFile1', 1)"
                            type="file"
                            accept="audio/*"
                            id="formFile1"
                          />
                        </v-card-title>
                      </v-card>
                      <v-card class="d-flex align-center justify-center" elevation="0" color="transparent">
                        <p class="custom-text">OR</p>
                      </v-card>

                      <v-card
                        elevation="0"
                        class="align-center justify-center"
                        color="#eeeeee"
                        style="border-radius: 10px"
                      >
                        <v-progress-linear :indeterminate="isRecording1"></v-progress-linear>

                        <v-card-title style="margin-top: -25px" class="subheading justify-center">
                          {{ !isRecording1 ? "Record your voice" : "Recording" }}
                          <v-btn
                            small
                            @click="!isRecording1 ? startRecording(1) : stopRecording(1)"
                            fab
                            dark
                            color="#18739d"
                          >
                            <v-icon v-if="!isRecording1" dark> mic </v-icon>

                            <v-icon v-else dark> stop </v-icon>
                          </v-btn></v-card-title
                        >
                      </v-card>

                      <div class="speaker-1" style="max-width: 300px">
                        <v-subheader id="audio1txt">Speaker 1 : Select speaker below</v-subheader>

                        <audio id="audio1" controls>
                          <source id="audio1src" src="" type="audio/wav" />
                          Your browser does not support the audio element.
                        </audio>
                      </div>
                    </div>
                  </v-layout>
                </v-container>
              </v-flex>

              <v-flex xs12 sm6 md6 lg6>
                <v-container fluid fill-height>
                  <v-layout class="align-center justify-center">
                    <div style="text-align: center">
                      <span class="title custom-text">Select Speaker #2 </span>
                      <p class="title custom-text" style="margin-top: 5px">
                        <span style="font-size: 30px">&#8681;</span>
                      </p>
                      <v-card
                        height="55"
                        elevation="0"
                        class="d-flex align-center justify-center"
                        color="#eeeeee"
                        style="border-radius: 10px"
                      >
                        <v-select
                          style="margin-top: 5px; width: 10px"
                          :items="audios2"
                          label="Choose a preloaded sample"
                          @change="loadaudio(2, $event)"
                        >
                        </v-select>
                      </v-card>
                      <v-card class="d-flex align-center justify-center" elevation="0" color="transparent">
                        <p class="custom-text">OR</p>
                      </v-card>

                      <v-card
                        height="55"
                        elevation="0"
                        class="d-flex align-center justify-center"
                        color="#eeeeee"
                        style="border-radius: 10px"
                      >
                        <div class="file-upload justify-center">
                          <input
                            style="width: 200px"
                            class="form-control"
                            @change="customaudio('formFile2', 2)"
                            type="file"
                            accept="audio/*"
                            id="formFile2"
                          />
                        </div>
                      </v-card>
                      <v-card class="d-flex align-center justify-center" elevation="0" color="transparent">
                        <p class="custom-text">OR</p>
                      </v-card>

                      <v-card
                        elevation="0"
                        class="align-center justify-center"
                        color="#eeeeee"
                        style="border-radius: 10px"
                      >
                        <v-progress-linear :indeterminate="isRecording2"></v-progress-linear>

                        <v-card-title style="margin-top: -25px" class="subheading justify-center"
                          >{{ !isRecording2 ? "Record your voice" : "Recording" }}
                          <v-btn
                            small
                            @click="!isRecording2 ? startRecording(2) : stopRecording(2)"
                            fab
                            dark
                            color="#18739d"
                          >
                            <v-icon v-if="!isRecording2" dark> mic </v-icon>

                            <v-icon v-else dark> stop </v-icon>
                          </v-btn></v-card-title
                        >
                      </v-card>

                      <div class="speaker-2" style="max-width: 300px">
                        <v-subheader id="audio2txt">Speaker 2 : Select speaker below</v-subheader>

                        <audio id="audio2" controls>
                          <source id="audio2src" src="" type="audio/wav" />
                          Your browser does not support the audio element.
                        </audio>
                      </div>
                    </div>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>

          <v-container fluid fill-height>
            <v-layout row wrap class="align-center justify-center">
              <v-flex xs12 sm6 md3 xl3 lg3>
                <div>
                  <v-btn
                    @click="getprediction()"
                    depressed
                    color="#18739d"
                    style="color: white; border-radius: 15px; width: 200px; height: 55px; font-size: 30px"
                    >Submit</v-btn
                  >
                </div>
              </v-flex>
              <v-flex xs12 sm6 md3 xl3 lg4>
                <h2 style="text-align: center">Model Voice Matching Result:</h2>
                <h1 v-if="!loading" :class="predictioncl" id="prediction" style="text-align: center; margin-top: 5%">
                  {{ predictionResult }} <br />
                </h1>
                <h3 v-if="!loading">{{ voiceGenuiness }}</h3>
                <h3 v-if="!loading">{{ multiVoices }}</h3>

                <v-progress-circular v-if="loading" indeterminate color="primary"></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-layout>
      </v-container>
    </v-app>
  </div>
</template>


<script>
import axios from "axios";

axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
axios.defaults.withCredentials = false;

// console.log("landed!");

export default {
  name: "VoicePrint",
  data() {
    return {
      loading: false,
      predictioncl: "",
      predictionResult: "--",
      voiceGenuiness: "--",
      multiVoices: "--",
      audios1: [
        "cate_blanch.wav",
        "denzel_washington.wav",
        "leonardo_dicaprio.wav",
        "aamir_khan.wav",
        "robotic_000.wav",
      ],
      audios2: [
        "cate_blanch_2.wav",
        "denzel_washington_2.wav",
        "leonardo_dicaprio_2.wav",
        "aamir_khan_2.wav",
        "robotic_001.wav",
      ],
      api_url: "https://showroom.privately.swiss:8081",
      progressValue: 0,
      processingDone1: false,
      processingDone2: false,
      isRecording1: false,
      isRecording2: false,
      audioStopped: false,
      audioRecorder: null,
      audioChunks: [],
      displayedText: "Recording...",
      constraints: {
        audio: {
          sampleRate: 16000,
          channelCount: 1,
        },
      },
    };
  },
  methods: {
    loadaudio(speaker_no, audio_name) {
      var audio = document.getElementById("audio" + speaker_no);
      this.resetpredictionlabel();
      if (speaker_no == 1) {
        this.resetButtons("audio1btn");
      } else if (speaker_no == 2) {
        this.resetButtons("audio2btn");
      }

      this.getaudio(speaker_no, audio_name);

      // document.getElementById("audio"+speaker_no+"src").src = "./assets/audios/" + audio_name;
      document.getElementById("audio" + speaker_no + "txt").innerHTML = "Speaker " + speaker_no + " : " + audio_name;
      audio.load();
    },
    resetButtons(btnclass) {
      var btns = document.getElementsByClassName(btnclass);
      for (let i = 0; i < btns.length; i++) {
        btns[i].innerHTML = "Try";
        // console.log(btns[0].innerHTML);
      }
    },
    getaudio(speaker_no, audio_name) {
      const options = {
        url: this.api_url + "/showroom/voicesamples",
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        data: {
          audioname: audio_name,
        },
      };
      axios(options)
        .then((res) => {
          document.getElementById("audio" + speaker_no + "src").src =
            "data:audio/wav;base64," + res.data["audio_base64"];
          var audio = document.getElementById("audio" + speaker_no);
          audio.load();
        })
        .catch((err) => console.log("Audio fetching error occurred:" + err));
    },
    customaudio(form_id, speaker_no) {
      this.resetpredictionlabel();

      this.resetButtons("audio" + speaker_no + "btn");

      // console.log(document.getElementById(form_id).files[0]);
      var file = document.getElementById(form_id).files[0];

      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = function () {
        var base64data1 = reader.result;
        var aud = document.getElementById("audio" + speaker_no);
        document.getElementById("audio" + speaker_no + "src").src = base64data1;
        // document.getElementById('audio1').src = base64data1;
        aud.load();
        document.getElementById("audio" + speaker_no + "txt").innerHTML = "Speaker " + speaker_no + " : " + file.name;
        document.getElementById("form" + speaker_no + "btn").innerHTML = "Selected";
      };
    },

    getprediction() {
      // console.log("entered prediction");
      // console.log(document.getElementById("audio1src").src);
      if (
        document.getElementById("audio1src").src.length < 50 ||
        document.getElementById("audio2src").src.length < 50
      ) {
        alert("Audio Files not selected ! Please select both audio files");
      } else {
        this.loading = true;
        var data = {
          audio_data1: document.getElementById("audio1src").src.slice(22),
          audio_data2: document.getElementById("audio2src").src.slice(22),
        };
        // console.log(data);
        // Storing response
        const options = {
          url: this.api_url + "/showroom/voiceprint",
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          data: data,
        };
        axios(options)
          .then((res) => {
            this.loading = false;
            console.log(res.data);
            if (res.data["prediction"] == "matched") {
              this.predictionResult = "Voices Matched";
              this.predictioncl = "match";
            } else if (res.data["prediction"] == "Not matched") {
              this.predictionResult = "Voices did not match";
              this.predictioncl = "nomatch";
            } else {
              this.predictionResult = "Error";
              this.predictioncl = "nomatch";
            }
            this.voiceGenuiness = "Audio 1: " + res.data["voice1_type"] + " | Audio 2: " + res.data["voice2_type"];
            this.multiVoices =
              "Person count : " + res.data["voice1_multi"] + " | Person count : " + res.data["voice2_multi"];
          })
          .catch((err) => {
            this.loading = false;
            console.log("The following API prediction error occurred:" + err);
          });
      }
    },
    resetpredictionlabel() {
      document.getElementById("prediction").innerHTML = "--";
      document.getElementById("prediction").style.color = "#000000";
    },
    loadRecordedAudio(speaker_no) {
      var superBuffer = new Blob(this.audioChunks, { type: "audio/wav" });
      console.log("Print buffer");
      console.log(superBuffer);
      var reader = new window.FileReader();
      var rec_audio = reader.readAsDataURL(superBuffer);
      // console.log(rec_audio);
      reader.onloadend = function () {
        var base64 = reader.result;
        console.log(base64);
        // base64 = base64.split(",")[1];
        document.getElementById("audio" + speaker_no + "src").src = base64;
        document.getElementById("audio" + speaker_no + "txt").innerHTML =
          "Speaker " + speaker_no + " : " + "recorded_audio" + speaker_no + ".wav";
        var audio = document.getElementById("audio" + speaker_no);
        audio.load();
      };
    },
    startRecording(speaker_no) {
      this.resetButtons("audio" + speaker_no + "btn");
      this.resetpredictionlabel();
      this.audioChunks = [];
      this.progressValue = 0;
      var ref = this;
      this.processingDone = false;
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia(this.constraints)
          .then(function (stream) {
            ref.audioRecorder = new MediaRecorder(stream);

            ref.audioRecorder.start();
            if (speaker_no == 1) {
              ref.fireProgressBar1();
              ref.isRecording1 = true;
            } else {
              ref.fireProgressBar2();
              ref.isRecording2 = true;
            }
            console.log(ref.audioRecorder.state);
            console.log("recorder started");

            ref.audioRecorder.ondataavailable = function (e) {
              console.log("data pushed");
              ref.audioChunks.push(e.data);
              ref.loadRecordedAudio(speaker_no);
            };
          })
          .catch(function (err) {
            console.log("The following getUserMedia error occurred: " + err);
          });
      } else {
        console.log("getUserMedia not supported on your browser!");
      }
    },
    async stopRecording(speaker_no) {
      this.audioRecorder.stop();
      if (speaker_no == 1) {
        this.isRecording1 = false;
      } else {
        this.isRecording2 = false;
      }
      // this.isRecording = false;

      clearInterval(this.timer);
      this.progressValue = 0;
      console.log("recording stopped");

      await new Promise((resolve) => setTimeout(resolve, 10));

      var superBuffer = new Blob(this.audioChunks, { type: "audio/wav" });
      // console.log("Print buffer")
      // console.log(superBuffer)
      var reader = new window.FileReader();
      var rec_audio = reader.readAsDataURL(superBuffer);
      console.log(rec_audio);
      reader.onloadend = function () {
        var base64 = reader.result;
        // console.log(base64)
        // base64 = base64.split(",")[1];
        document.getElementById("audio" + speaker_no + "src").src = base64;
        document.getElementById("audio" + speaker_no + "txt").innerHTML =
          "Speaker " + speaker_no + " : " + "recorded_audio" + speaker_no + ".wav";
        var audio = document.getElementById("audio" + speaker_no);
        audio.load();
      };
    },
    fireProgressBar1() {
      this.timer = setInterval(() => {
        this.progressValue += 1.3;
      }, 100);
      setTimeout(() => {
        if (this.isRecording1) {
          this.stopRecording(1);
          clearInterval(this.timer);
          this.progressValue = 0;
        }
      }, 8000);
    },
    fireProgressBar2() {
      this.timer = setInterval(() => {
        this.progressValue += 1.3;
      }, 100);
      setTimeout(() => {
        if (this.isRecording2) {
          this.stopRecording(2);
          clearInterval(this.timer);
          this.progressValue = 0;
        }
      }, 8000);
    },
  },
};
</script>
<style scoped>
.custom-text {
  font-family: Fredoka One;
  font-style: normal;
  font-weight: normal;
  font-size: 23px;
  line-height: 52px;
  text-align: center;
  color: #18739d;
  margin: 0px 0px;
}
.match {
  color: #3cb371;
}
.nomatch {
  color: #ff0000;
}
input[type="file"]::file-selector-button {
  -webkit-text-size-adjust: 100%;
  box-sizing: inherit;
  background-repeat: no-repeat;
  border-style: none;
  display: inline-flex;
  -webkit-box-flex: 0;
  justify-content: center;
  margin: 6px 8px;
  user-select: none;
  cursor: pointer;
  font-weight: bold;
  background-color: rgb(24, 115, 157);
  border-color: rgb(24, 115, 157);
  color: white;
  border-radius: 15px;
  font-size: 15px;
}
</style>


